export const getRefererUrlAfterAuthentication = (state) => state.entities.users.refererAfterAuthenticateUrl;
